import $ from 'jquery';

$(() => {
	$(document).on('gform_confirmation_loaded', (e, formid) => {
		window.location.href = '#thankyou';
	} );
});
